<div class="buyer-agent-form">
  <form [formGroup]="form" [ngClass]="{ 'show-errors-on-touched': errorCondition.touch }">
    <div class="mt-1">
      <div class="p-fluid row">
        @for (field of buyerAgentFormFeilds; track field) {
          @switch (field.type) {
            @case ('dropdown') {
              <div class="col" [ngClass]="field.class ?? 'col-12'">
                @if (field.label) {
                  <label [for]="field.formControlName ?? ''">
                    {{ field.label || field.placeholder || '' }}
                  </label>
                }
                <p-select
                  [options]="field?.options ?? []"
                  [id]="field.formControlName"
                  [formControlName]="field.formControlName ?? ''"
                  [placeholder]="field.placeholder ?? ''"
                  [showTransitionOptions]="'100ms'"
                  [hideTransitionOptions]="'50ms'" />
                <app-input-error
                  [controlName]="field.formControlName ?? ''"
                  [friendlyName]="field.label ?? field.placeholder ?? ''"
                  [errorCondition]="errorCondition"
                  [anyErrorShowInvalid]="field.anyErrorShowInvalid ?? false"
                  [customErrorMessage]="field.customErrorMessage ?? null" />
              </div>
            }
            @case ('inputmask') {
              <div class="col" [ngClass]="field.class ?? 'col-12'">
                @if (field.label) {
                  <label [for]="field.formControlName ?? ''">
                    {{ field.label || field.placeholder || '' }}
                  </label>
                }
                <p-inputMask
                  [id]="field.formControlName ?? ''"
                  [formControlName]="field.formControlName ?? ''"
                  [mask]="field.mask ?? ''"
                  [slotChar]="field.slotChar ?? ' '"
                  [placeholder]="field.placeholder ?? ''" />
                <app-input-error
                  [controlName]="field.formControlName ?? ''"
                  [friendlyName]="field.label ?? field.placeholder ?? ''"
                  [errorCondition]="errorCondition"
                  [anyErrorShowInvalid]="field.anyErrorShowInvalid ?? false"
                  [customErrorMessage]="field.customErrorMessage ?? null" />
              </div>
            }
            @default {
              <div class="col" [ngClass]="field.class ?? 'col-12'">
                @if (field.label) {
                  <label [for]="field.formControlName ?? ''">
                    {{ field.label || '' }}
                  </label>
                }
                <input
                  [formControlName]="field.formControlName ?? ''"
                  [placeholder]="field.placeholder ?? ''"
                  [type]="field.type ?? 'text'"
                  [id]="field.formControlName ?? ''"
                  pInputText />
                <app-input-error
                  [controlName]="field.formControlName ?? ''"
                  [friendlyName]="field.label ?? field.placeholder ?? ''"
                  [errorCondition]="errorCondition"
                  [anyErrorShowInvalid]="field.anyErrorShowInvalid ?? false"
                  [customErrorMessage]="field.customErrorMessage ?? null" />
              </div>
            }
          }
        }
      </div>
    </div>
  </form>
</div>
